module.exports = "/_next/static/images/success-plus-graph-1fe9b80971bc5302e2a74dd572959d01.png";